/**
 * Designed  & Developed by Faisal Nadaf
 * Contact: faisalfnadaf@gmail.com
 *
 * @format
 */

import { Navigation } from "@/components/customCopmonent/landingSection/navigation";
import { FooterSection } from "@/components/customCopmonent/landingSection/footer-section";
import CircularGallery from "@/components/customCopmonent/CircularGallery";
import DotGrid from "@/components/customCopmonent/DotGrid";
import { PageHeaderHero, PAGE_HERO_CLASS } from "@/components/customCopmonent/Text/PageHeaderHero";
import { SectionWrapper } from "../Clientele.page-primitives";
import { PageHeader } from "@/components/customCopmonent/Text/PageHeader";
import { RevealOnScroll } from "@/components/SpecialProjectsPage.primitives";
import Seo from "@/components/Seo";
import { useIsMobile } from "@/hooks/hooks/use-mobile";

import React, { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import {
	IndustrySectionProduct,
	IndustrySectionApplication,
} from "@/components/customCopmonent/IndustryCardsAP";

// Register ScrollTrigger
if (typeof window !== "undefined") {
	gsap.registerPlugin(ScrollTrigger);
}

const SUB_INDUSTRY_IMAGES = [
	"/images/industriesPhotos/ChemicalProcessing/SubIndustries/Specialty_Chemical_Plants.webp",
	"/images/industriesPhotos/ChemicalProcessing/SubIndustries/Bulk_Chemical_Plants.webp",
	"/images/industriesPhotos/ChemicalProcessing/SubIndustries/Fertilizer_Plants.webp",
	"/images/industriesPhotos/ChemicalProcessing/SubIndustries/Agrochemical_Plant.webp",
	"/images/industriesPhotos/ChemicalProcessing/SubIndustries/Polymer_&_Resin_Plants.jpg",
];

const APPLICATION_IMAGES = [
	"/images/industriesPhotos/ChemicalProcessing/Application/Process_Fluid_Heatin&Cooling.jpg",
	"/images/industriesPhotos/ChemicalProcessing/Application/Condensation_of_Vapors.webp",
	"/images/industriesPhotos/ChemicalProcessing/Application/Evaporation_Processes.webp",
	"/images/industriesPhotos/ChemicalProcessing/Application/Corrosive_Fluid_Heat_Transfer.webp",
];

const ChemicalProcessing = () => {
	const { t } = useTranslation();

	const subIndustryTexts = t(
		"industryPages.chemicalProcessing.subIndustries.items",
		{ returnObjects: true },
	) as string[];
	const applicationItems = t(
		"industryPages.chemicalProcessing.applications.items",
		{ returnObjects: true },
	) as { title: string; description: string }[];

	const pageData = {
		title: t("industryPages.chemicalProcessing.title"),
		bgimage: "/images/header/chemical.webp",
		description: t("industryPages.chemicalProcessing.tagline"),
		meta: t("industryPages.chemicalProcessing.meta", {
			returnObjects: true,
		}) as string[],
		subIndustries: {
			title: t("industryPages.chemicalProcessing.subIndustries.title"),
			industries: SUB_INDUSTRY_IMAGES.map((image, i) => ({
				image,
				text: subIndustryTexts[i],
			})),
		},
		applications: {
			title: t("industryPages.chemicalProcessing.applications.title"),
			applications: APPLICATION_IMAGES.map((image, i) => ({
				image,
				title: applicationItems[i]?.title,
				description: applicationItems[i]?.description,
			})),
		},
	};
	const isMobile = useIsMobile();

	return (
		<>
			<Seo
				titleKey="industryPages.chemicalProcessing.seo.title"
				descriptionKey="industryPages.chemicalProcessing.seo.description"
				path="/industries/chemical-fertilizer"
			/>
			<Navigation />
			<SectionWrapper className={PAGE_HERO_CLASS}>
				<div className="absolute inset-0 ">
					{" "}
					<div
						className="absolute bottom-3 inset-0 opacity-35 scale-105"
						style={{
							backgroundImage: `url(${pageData.bgimage})`,
							backgroundSize: "cover",
							backgroundPosition: "center",
						}}
					/>
					<DotGrid
						dotSize={4}
						gap={15}
						baseColor="#3b0092"
						activeColor="#f09a38"
						proximity={100}
						shockRadius={200}
						shockStrength={3}
						resistance={750}
						returnDuration={1.5}
					/>
				</div>
				<PageHeaderHero
					// align="center"
					title={pageData.title}
					description={pageData.description}
					meta={pageData.meta}
				/>{" "}
			</SectionWrapper>

			<SectionWrapper
				className="pt-0  !px-0 !max-w-none"
				contentClassName="!max-w-none !px-0">
				{" "}
				<div className="relative flex flex-col items-center justify-center ">
					{/* ===== HEADER ===== */}
					<RevealOnScroll>
						<PageHeader
							title={pageData.subIndustries.title}
							align="center"
							className="py-6 text-center items-center "
						/>
					</RevealOnScroll>
				</div>
				<div className="relative h-[360px] sm:h-[460px] lg:h-[600px]">
					<CircularGallery
						items={pageData.subIndustries.industries}
						textColor="#000"
						borderRadius={0.05}
						bend={isMobile ? 0 : -3}
						scrollSpeed={1.5}
						scrollEase={0.05}
					/>
				</div>
			</SectionWrapper>
			<SectionWrapper
				className="pt-0  !px-0 !max-w-none"
				contentClassName="!max-w-none !px-0">
				<IndustrySectionApplication
					applications={pageData.applications.applications}
					title={pageData.applications.title}
				/>{" "}
			</SectionWrapper>
			{/* <SectionWrapper
				className="pt-0  !px-0 !max-w-none"
				contentClassName="!max-w-none !px-0">
				<IndustrySectionProduct
					applications={pageData.products.products}
					title={pageData.products.title}
					description={pageData.products.description}
				/>{" "}
			</SectionWrapper> */}
			<FooterSection />
		</>
	);
};

export default ChemicalProcessing;
